import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true // Optional if using standalone components
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: Date | string | number): string {
    if (!value) return 'Just now';

    let date = new Date(value);
    
    // Check if the value is a string and likely doesn't have timezone info (e.g. "2024-03-12T10:00:00")
    // When C# backend sends DateTime without offset, it's typically UTC, but JS parses it locally
    if (typeof value === 'string' && !value.endsWith('Z') && !value.includes('+') && !value.match(/-\d{2}:\d{2}$/)) {
      date = new Date(value + 'Z');
    }

    let seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

    if (seconds < 60) {
      return 'Just now';
    }

    const intervals: { [key: string]: number } = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60
    };

    for (const [unit, interval] of Object.entries(intervals)) {
      const count = Math.floor(seconds / interval);
      if (count >= 1) {
        return `${count} ${unit}${count > 1 ? 's' : ''} ago`;
      }
    }

    return 'Just now';
  }
}
